/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  align-items: flex-start;
  background-color: var(--qds-theme-accessory-background);
  border-radius: var(--qds-accessory-border-radius);
  border: none;
  box-shadow: var(--qds-accessory-elevation);
  box-sizing: border-box;
  color: var(--qds-theme-text-standard);
  display: flex;
  flex-direction: column;
  gap: var(--qds-accessory-gap-children-unrelated);
  margin: 0;
  overflow: initial;
  padding: 0;
}

:host::before {
  content: '';
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

::slotted(blockquote),
::slotted(button),
::slotted(dd),
::slotted(dl),
::slotted(fieldset),
::slotted(figure),
::slotted(h1),
::slotted(h2),
::slotted(h3),
::slotted(h4),
::slotted(h5),
::slotted(h6),
::slotted(hr),
::slotted(input),
::slotted(menu),
::slotted(ol),
::slotted(p),
::slotted(pre),
::slotted(select),
::slotted(textarea),
::slotted(ul) {
  margin: 0;
}

:host([data-side='top'])::before,
:host([data-side='bottom'])::before {
  height: calc(
    var(--qds-accessory-gap-floating, 0px) +
      var(--qds-signature-triangle-pointer-size-height, 0px)
  );
  top: 100%;
}

:host([data-side='bottom'])::before {
  top: calc(
    -1 *
      (
        var(--qds-accessory-gap-floating, 0px) +
          var(--qds-signature-triangle-pointer-size-height, 0px)
      )
  );
}

:host([data-side='left'])::before,
:host([data-side='right'])::before {
  width: calc(
    var(--qds-accessory-gap-floating, 0px) +
      var(--qds-signature-triangle-pointer-size-height, 0px)
  );
  left: 100%;
}

:host([data-side='right'])::before {
  left: calc(
    -1 *
      (
        var(--qds-accessory-gap-floating, 0px) +
          var(--qds-signature-triangle-pointer-size-height, 0px)
      )
  );
}

.qds-arrow {
  position: absolute;
  width: var(--qds-signature-triangle-pointer-size-width);
  height: var(--qds-signature-triangle-pointer-size-height);

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--qds-theme-accessory-background);
    clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: calc(100% + var(--qds-accessory-border-width));
    background-color: var(--qds-theme-accessory-border);
    clip-path: polygon(0% 10%, 100% 10%, 50% 100%);
    z-index: -1;
    bottom: calc(-1 * var(--qds-accessory-border-width));
  }

  &[data-side='bottom'] {
    top: calc(
      (
          var(--qds-signature-triangle-pointer-size-height) -
            var(--qds-accessory-effect-section-position-y)
        ) * -
        1
    );
    transform: rotate(180deg);
  }

  &[data-side='left'] {
    right: calc(
      (
          (
              var(--qds-accessory-gap-floating) +
                var(--qds-signature-triangle-pointer-size-height)
            ) *
            -1
        ) +
        var(--qds-accessory-effect-section-position-y)
    );
    transform: rotate(-90deg);
  }

  &[data-side='right'] {
    left: calc(
      (
          (
              var(--qds-accessory-gap-floating) +
                var(--qds-signature-triangle-pointer-size-height)
            ) *
            -1
        ) +
        var(--qds-accessory-effect-section-position-y)
    );
    transform: rotate(90deg);
  }

  &[data-side='top'] {
    bottom: calc(
      (
          var(--qds-signature-triangle-pointer-size-height) -
            var(--qds-accessory-effect-section-position-y)
        ) * -
        1
    );
  }
}

.qds-tooltip {
  border: var(--qds-accessory-border-width) solid
    var(--qds-theme-accessory-border);
  border-radius: var(--qds-accessory-border-radius);
  padding: var(--qds-accessory-padding-top) var(--qds-accessory-padding-end)
    var(--qds-accessory-padding-bottom) var(--qds-accessory-padding-start);
  display: inherit;
  flex-direction: inherit;
  flex-wrap: inherit;
  justify-content: inherit;
  align-items: inherit;
  gap: inherit;
  max-width: var(--qds-accessory-max-width);
}
